import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UnityService } from '@app/core';
import { Unity } from '@core/model/unity.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { error } from 'selenium-webdriver';

@Component({
  selector: 'app-unity-create',
  templateUrl: './unity-create.component.html',
  styleUrls: ['./unity-create.component.css']
})
export class UnityCreateComponent implements OnInit {
  unityForm: FormGroup;

  @Input() titulo: string;
  @Input() unity_id: string;
  @Input() estado: boolean;
  isLoading = false;
  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private unityService: UnityService
  ) {}

  ngOnInit() {
    this.createForm();
    if (this.estado === true) {
      this.editUnity(this.unity_id);
    }
  }

  createForm() {
    this.unityForm = this.formBuilder.group({
      abreviado: ['', [Validators.required]],
      nombre: ['', [Validators.required]]
    });
  }

  registerUnitys() {
    const newUnity = new Unity();
    newUnity.nombre = this.unityForm.value.nombre;
    newUnity.abreviado = this.unityForm.value.abreviado;
    if (this.estado === true) {
      this.unityService.update(this.unity_id, newUnity).subscribe(
        data => {
          Swal.fire(data);
          this.activeModal.close(data);
        },
        error2 => {
          Swal.fire(error2);
          this.activeModal.close();
        }
      );
    } else {
      this.unityService.create(newUnity).subscribe(
        data => {
          Swal.fire('Se creo correctamente');
          this.activeModal.close(data);
        },
        error1 => {
          // console.log(error);
          Swal.fire(error1);
          this.activeModal.close();
        }
      );
    }
  }

  editUnity(id: string) {
    this.unityService.getById(id).subscribe(data => {
      this.unityForm.setValue({
        abreviado: data.abreviado,
        nombre: data.nombre
      });
    });
  }
}
